import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { alertActions, certapplyActions } from '../../../../../store/actions'
import PopFiles from './PopFiles'
import history from '../../../../../route/history'
import moment from 'moment'
import { commons } from '../../../../../hook/common'

/**
 * 구매확인서 3단계 / 근거서류 목록
 */
const Step03 = (props) => {
  const [docid, setDocid] = useState()
  const [fileList, setFileList] = useState(props.stepData)
  const [showAddFiles, setShowAddFiles] = useState(false)

  const fileType = [
    { title: '수출신고필증', value: '811' },
    { title: 'Documentary credit(수출신용장)', value: '465' },
    { title: '외화표시 물품공급계약서', value: '2AN' },
  ]

  /**
   * 페이지 진입
   */
  useEffect(() => {
    let id = props.search?.split('=')[1]
    let key = props.search?.split('=')[0]

    if (id && key === '?id') {
      let data = JSON.parse(sessionStorage.getItem(id))

      //이전 페이지 정보가 없을 경우 첫 화면으로 이동
      if (!data || data?.step2?.length <= 0) {
        history.replace('/service/certapply/1?id=' + id)
        return
      }
      setDocid(id)
      setFileList(data.step3)
    } else {
      if (props.packageId === 0) {
        history.replace('/service/certapply/1')
      }
      if (props.packageId > 0) {
        setDocid(props.totalData?.step1?.docid)
        props.totalData?.step3 && setFileList(props.totalData?.step3)
      }
    }
  }, [])

  /**
   * 데이터 갱신
   */
  useEffect(() => {
    if (props.isCalled === true) {
      setFileList(props.stepData)
    }
    props.setCalled(false)
  }, [props?.isCalled])

  return (
    <React.Fragment>
      {showAddFiles && <PopFiles onClose={() => setShowAddFiles(false)} docid={docid} />}

      <h3 className="h3-tit mt30">근거 서류 정보</h3>
      <p className="text-box">외화획득용 원료 · 기재라는 사실을 증명하는 서류입니다.</p>
      <div className="list-header mt20">
        <span className="total-num">총 {fileList?.length}건</span>
        <span className="right">
          <a
            href="#"
            className="btn-secondary sm modal-popup"
            onClick={(e) => {
              e.preventDefault()
              setShowAddFiles(true)
            }}
          >
            근거서류 등록 / 수정
          </a>
        </span>
      </div>

      <div className="tbl-wrap">
        <table className="tbl-list">
          <caption>근거서류명, HS부호, 품명, 규격, 금액, 선적기일 항목으로 구성</caption>
          <colgroup>
            <col style={{ width: '17%' }} />
            <col style={{ width: '14%' }} />
            <col style={{ width: '25%' }} />
            <col style={{ width: '14%' }} />
            <col style={{ width: '14%' }} />
            <col />
          </colgroup>
          <thead>
            <tr>
              <th scope="col">근거서류명 및 번호</th>
              <th scope="col">HS부호</th>
              <th scope="col">품명</th>
              <th scope="col">규격</th>
              <th scope="col">금액</th>
              <th scope="col">선적기일</th>
            </tr>
          </thead>
          <tbody>
            {fileList?.length > 0 ? (
              fileList?.map((item, index) => {
                return (
                  <tr key={index}>
                    <td data-title={'근거서류명 및 번호'}>
                      {
                        fileType.find((file) => {
                          return file.value === item.fileCd
                        })?.title
                      }
                      <br />[{item.fileNo}]
                    </td>
                    <td data-title={'HS부호'}>{item.hsCd}</td>
                    <td data-title={'품명'}>{item.itemnm}</td>
                    <td data-title={'규격'}>{item.itemdeftxt}</td>
                    <td data-title={'금액'}>
                      {item.totamtcur} {commons.addComma(item.amt)}
                    </td>
                    <td data-title={'선적기일'}>{moment(item.stngYmd).format('Y-M-D')}</td>
                  </tr>
                )
              })
            ) : (
              <tr>
                <td colSpan={6}>
                  <div className="nodata">등록된 자료가 없습니다.</div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="list-footer">
        <span className="left">
          <a
            href="#"
            className="btn-secondary md"
            onClick={(e) => {
              e.preventDefault()
              props.doDelete()
            }}
          >
            취소
          </a>
        </span>
        <span className="right">
          <a
            href="#"
            className="btn-secondary md"
            onClick={(e) => {
              e.preventDefault()
              props.goStepPrev()
            }}
          >
            이전
          </a>
          <a
            href="#"
            className="btn-primary md"
            onClick={(e) => {
              e.preventDefault()
              props.goStepNext()
            }}
          >
            다음
          </a>
        </span>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    stepData: state.certapply?.data?.step3,
    totalData: state.certapply.data,
    isCalled: state.certapply.isCalled,
  }
}

const actionCreators = {
  setCalled: certapplyActions.setCalled,
  alert: certapplyActions.alert,
  error: alertActions.error,
}

export default connect(mapStateToProps, actionCreators)(Step03)
